<template>
  <UserLayout>
    <section class="mx-0 mt-14">
      <p class="font-semibold text-3xl leading-10 tracking-tight">Settings</p>
      <div class="flex my-8" :class="{ '-ml-4': currentTab !== 'Basics' }">
        <button
          class="bg-white font-medium text-sm py-2 px-4 focus:outline-none rounded-lg"
          :class="{ 'bg-green-light text-white': currentTab === 'Basics' }"
          @click="changeTab('Basics')"
        >
          Basics
        </button>
        <button
          class="bg-white font-medium text-sm py-2 px-4 focus:outline-none rounded-lg"
          :class="{
            'bg-green-light text-white': currentTab === 'PaymentSettings',
          }"
          @click="changeTab('PaymentSettings')"
        >
          Payment settings
        </button>
        <!-- <button
          class="bg-white font-medium text-sm py-2 px-4 focus:outline-none rounded-lg"
          :class="{ 'bg-green-light text-white': currentTab === 'Account' }"
          @click="changeTab('Account')"
        >
          Account
        </button>
        <button
          class="bg-white font-medium text-sm py-2 px-4 focus:outline-none rounded-lg"
          :class="{
            'bg-green-light text-white': currentTab === 'Notification',
          }"
          @click="changeTab('Notification')"
        >
          Notification
        </button> -->
      </div>
      <keep-alive>
        <component :is="currentTab"></component>
      </keep-alive>
    </section>
  </UserLayout>
</template>

<script>
import UserLayout from "@/components/layouts/UserLayout";
import Basics from "@/views/user/profile/Basics.vue";
import PaymentSettings from "@/views/user/profile/PaymentSettings.vue";

export default {
  name: "UserSettings",
  components: {
    UserLayout,
    Basics,
    PaymentSettings,
  },
  data() {
    return {
      currentTab: "Basics",
    };
  },
  methods: {
    changeTab(tab) {
      this.currentTab = tab;
    },
  },
};
</script>